module.exports = __webpack_public_path__ + "img/Kenneth.3a50878b.png";